import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import Button from "UI/Button";

export default function MediaPreview({src, onClick}) {

    const classes = {
        button: classNames(
            'group-hover:opacity-100 absolute flex inset-0 items-center justify-center',
            {
                'opacity-100': ! src,
                'opacity-0':  !! src
            }
        )
    };

    return <div className="relative group">
        <div
            className="border focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 block w-full aspect-w-10 aspect-h-5 rounded-lg overflow-hidden bg-gray-50">
            {
                // If there is no src, hide the image to prevent a placeholder border we cannot style.
                // This wont prevent broken images showing a placeholder, though.
                src && <img src={src} alt="" className="group-hover:opacity-75 object-cover pointer-events-none" />
            }
        </div>
        <div className={classes.button}>
            <Button onClick={onClick}>Choose image</Button>
        </div>
    </div>;
}

MediaPreview.propTypes = {
    src: PropTypes.string.isRequired,
};

MediaPreview.defaultProps = {

};
